import React, { useEffect, useRef } from 'react';
import HeroImage from './hero-image';
import HeroVideo from './hero-video';

interface HeroShellProps {
  modifiers?: string;
  parallax?: boolean;
  video?: string;
  imageDesktop?: string;
  imageMobile?: string;
  children: React.ReactNode;
}

const HeroShell = ({
  modifiers,
  parallax,
  video,
  imageDesktop,
  imageMobile,
  children,
}: HeroShellProps) => {
  const heroRef = useRef<HTMLDivElement | null>(null);

  const onScroll = () => {
    if (document.documentElement) {
      const offset = document.documentElement.scrollTop * 0.25;
      if (heroRef.current) heroRef.current.style.transform = `translateY(${offset}px)`;
    }
  };

  useEffect(() => {
    if (parallax) {
      window.addEventListener('scroll', onScroll);
    } else {
      window.removeEventListener('scroll', onScroll);
    }
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [parallax]);

  return (
    <div data-wx-hero={modifiers}>
      <div className="hero">
        <div className="hero-media">
          {!video && <div className="hero-background-image" ref={heroRef} />}
          <HeroVideo video={video} />
        </div>
        <div className="hero-content">{children}</div>
      </div>
      {!video && <HeroImage imageDesktop={imageDesktop} imageMobile={imageMobile} />}
    </div>
  );
};

export default HeroShell;
